import styled from "styled-components";
import { Tooltip } from "react-tooltip";
import { SVGInfo, SVGEcoFillSmall, SVGCross } from "@/lib/svg";
import {
  bigLabelTypographicStyle,
  smallLabelTypographicStyle,
} from "@/lib/styles/helpers";

export const Container = styled.span`
  display: inline-flex;
  margin-left: 0.5rem;

  > a {
    display: flex;
  }
`;

export const EcoLabel = styled.div`
  display: flex;
  margin-bottom: 1rem;
  ${smallLabelTypographicStyle}
  font-weight: 700;
  color: ${({ theme }) => theme.colors.greenEco};
`;

export const Body = styled.p`
  ${smallLabelTypographicStyle}
`;

export const CloseTooltip = styled.div`
  display: flex;
  position: absolute;
  right: 1rem;
  top: 1rem;
  cursor: pointer;
`;

export const InfoIcon = styled(SVGInfo)`
  width: 1em;
  font-size: 1.25rem;
  cursor: pointer;
`;

export const EcoIcon = styled(SVGEcoFillSmall)`
  width: 1em;
  font-size: 1.25rem;
  margin-right: 0.5rem;
`;

export const CloseIcon = styled(SVGCross)`
  width: 1rem;
  height: auto;
`;

export const StyledTooltip = styled(Tooltip)`
  &.react-tooltip {
    width: 15rem;
    background: var(--background-grey, #f5f5f5);
    color: black;
    border-radius: 4px;
    opacity: 1;
    padding: 1rem;
    box-shadow: 0px 3px 6px 0px rgba(37, 38, 46, 0.16);
    z-index: 1;
    pointer-events: all;
    text-transform: none;
  }
`;
